import { ApolloProvider } from '@apollo/client';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';

import App from './app/app';
import apolloClient from './services/apollo/client';
import { regexes } from '@frontend/utils';

Sentry.init({
  dsn: process.env['NX_SENTRY_DSN_PAYMENTWIDGET'],
  environment: process.env['NX_ENVIRONMENT'],
  release: process.env['NX_RELEASE_NAME'],
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
    }),
    Sentry.thirdPartyErrorFilterIntegration({
      // Specify the application keys that you specified in the Sentry bundler plugin
      filterKeys: [process.env['NX_SENTRY_APPLICATION_KEY'] as string],
      behaviour: 'apply-tag-if-contains-third-party-frames',
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  beforeSend(event, hint) {
    if (event.request && event.request.url) {
      const uuidMatch = event.request.url.match(regexes.UUID);
      const uuid = uuidMatch ? uuidMatch[1] : null;

      if (!uuid) {
        return event;
      }

      event.extra = {
        uuid,
      };

      event.request.url = event.request.url.replace(regexes.UUID, '[bill-id]');
      event.transaction = '/[bill-id]';
      event.tags = {
        billId: uuid,
      };
    }

    return event;
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <StrictMode>
    <ApolloProvider client={apolloClient}>
      <App />
    </ApolloProvider>
  </StrictMode>
);
